import React from "react";

export default function Designcards(props) {
  return (
    <div>
      <div className="card shadow">
        <img
          src={props.imgsrc}
          //Prevents right click on image
          onContextMenu={(e) => e.preventDefault()}
          className="card-img-top ytdesigns"
          alt="img-design"
        />
        <div className="card-body">
          <h5 className="card-title">
            <strong>{props.title}</strong>
          </h5>
          <p className="card-text text-muted">{props.about.slice(0, 207)}</p>
          {props.weburl && ( // Check if weburl is provided
            <a href={props.weburl}>
              <i
                className="fa-solid fa-arrow-up-right-from-square"
                style={{ color: "#e85a71" }}
              ></i>
            </a>
          )}
        </div>
      </div>
    </div>
  );
}
